export default "__VITE_ASSET__BBnJ7pvS__"